import Panel from './Panel';
import PanelSkeletons from './PanelSkeletons';
import { PanelWithoutHeader } from './PanelWithoutHeader';
import { SimplePanel } from './SimplePanel';
import { PanelWithTitleOutside } from './PanelWithTitleOutside';

export { PanelSkeletons, PanelWithoutHeader, SimplePanel, PanelWithTitleOutside };
export default Panel;
